import script from "./CWorkPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CWorkPreview.vue?vue&type=script&setup=true&lang=ts"

import "./CWorkPreview.vue?vue&type=style&index=0&id=07564328&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07564328"]])

export default __exports__